import React, { Component } from 'react';
import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import { PlusIcon } from '@heroicons/react/solid';
import $ from 'jquery';
import { Carousel } from 'antd';
import { getCurrentLanguage, numAutoAdd } from '../utils/utils';
import { homeBanners, clientLogos } from '../data/home';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    let done = false;
    let top = $('.home_introductions').offset().top;
    let scrollTop = $(document).scrollTop();
    let windowHeight = $(window).height();

    if (parseInt(top) < parseInt(windowHeight)) {
      numAutoAdd($('.numAutoAdd:eq(0)'), { num: 5000 });
      numAutoAdd($('.numAutoAdd:eq(1)'), { num: 30 });
      numAutoAdd($('.numAutoAdd:eq(2)'), { num: 15000 });

      return (done = true);
    }

    $(document).scroll(function () {
      if (!done && top) {
        if (parseInt(scrollTop) + parseInt(windowHeight) >= parseInt(top)) {
          let lang = getCurrentLanguage();
          if (lang === 'cn') {
            numAutoAdd($('.numAutoAdd:eq(0)'), { num: 5000 });
            numAutoAdd($('.numAutoAdd:eq(1)'), { num: 30 });
            numAutoAdd($('.numAutoAdd:eq(2)'), { num: 15000 });
          }
          if (lang === 'en') {
            numAutoAdd($('.numAutoAdd:eq(0)'), { num: 5000, value: '5000' });
            numAutoAdd($('.numAutoAdd:eq(1)'), { num: 30 });
            numAutoAdd($('.numAutoAdd:eq(2)'), { num: 15000 });
          }
          done = true;
        }
      }
    });
  }

  render() {
    return (
      <>
        <Head>
          <meta
            name="keywords"
            content="Google广告，Facebook推广，谷歌代理，海外营销推广，广告投放优化"
          />
          <meta
            name="description"
            content="Hidream讯梦国际专注中国企业海外推广的营销全案公司，为出海企业提供广告投放、品牌孵化、社媒运营、独立站建站服务等。Hidream助力中国企业打造海外品牌，圆梦跨境！"
          />
        </Head>

        <div id="home" className="home">
          <div className="home_banner">
            <Carousel autoplay autoplaySpeed={8000} dots={false}>
              {homeBanners.map((banner) => {
                return (
                  <Link href={banner.link} key={banner.alt}>
                    <a>
                      <Image
                        src={banner.image}
                        alt="banner"
                        priority
                        layout="responsive"
                      />
                    </a>
                  </Link>
                );
              })}
            </Carousel>
          </div>

          <div className="home_introductions">
            <ul className="row">
              <li className="col">
                <div className="title">
                  <h3>千万美金</h3>
                  <span></span>
                </div>
                <p>广告实操经验团队</p>
              </li>
              <li className="col">
                <div className="title">
                  <h3 className="numAutoAdd">5000</h3>
                  <span>
                    <PlusIcon className="h-5 w-5" aria-hidden="true" />
                  </span>
                </div>
                <p>广告实操经验团队</p>
              </li>
              <li className="col">
                <div className="title">
                  <h3 className="numAutoAdd">30</h3>
                  <span>个</span>
                </div>
                <p>百万级DTC品牌成功孵化</p>
              </li>
              <li className="col">
                <div className="title">
                  <h3 className="numAutoAdd">15000</h3>
                  <span>
                    <PlusIcon className="h-5 w-5" aria-hidden="true" />
                  </span>
                </div>
                <p>跨境电商人才培训</p>
              </li>
            </ul>
          </div>

          <div className="home_service">
            <div className="header">
              <div className="section_header">
                <h3 className="title_cn">我们的服务</h3>
                <p className="title_en">Our service</p>
              </div>
            </div>

            <div className="section_banner">
              <Image
                src={require('../public/images/banner-1-1.jpg').default}
                alt="our service"
              />
            </div>

            <div className="section_content">
              <Tab>
                <div
                  className="wrapper"
                  name={
                    <div className="item-title">
                      <span className="iconfont">
                        <svg className="icon" aria-hidden="true">
                          <use xlinkHref="#icon-hidream-mguanggaotoufang"></use>
                        </svg>
                      </span>
                      <span>广告投放</span>
                    </div>
                  }
                >
                  <div className="content">
                    <p>
                      从素材制作到广告投放一站式解决，帮助广告主精准定位用户，有效提升ROI。
                    </p>

                    <div className="row">
                      <div className="col">
                        <svg className="icon" aria-hidden="true">
                          <use xlinkHref="#icon-hidream-mmeijieziyuan"></use>
                        </svg>
                        <div className="tag_name">媒介资源合作</div>
                      </div>
                      <div className="col">
                        <svg className="icon" aria-hidden="true">
                          <use xlinkHref="#icon-hidream-mguanggaosucai"></use>
                        </svg>
                        <div className="tag_name">广告素材制作</div>
                      </div>
                      <div className="col">
                        <svg className="icon" aria-hidden="true">
                          <use xlinkHref="#icon-hidream-mdingzhivi"></use>
                        </svg>
                        <div className="tag_name">定制VI体系</div>
                      </div>
                      <div className="col">
                        <svg className="icon" aria-hidden="true">
                          <use xlinkHref="#icon-hidream-mguanggaoyouhua"></use>
                        </svg>
                        <div className="tag_name">广告优化</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="wrapper"
                  name={
                    <div className="item-title">
                      <span className="iconfont">
                        <svg className="icon" aria-hidden="true">
                          <use xlinkHref="#icon-hidream-mdaiyunyingfuhua"></use>
                        </svg>
                      </span>
                      <span>品牌孵化</span>
                    </div>
                  }
                >
                  <div className="content">
                    <p>
                      从品牌定位到海外市场营销一站式解决，助力企业成功出海。
                    </p>

                    <div className="row">
                      <div className="col">
                        <svg className="icon" aria-hidden="true">
                          <use xlinkHref="#icon-hidream-myingxiaozixun"></use>
                        </svg>
                        <div className="tag_name">营销咨询</div>
                      </div>
                      <div className="col">
                        <svg className="icon" aria-hidden="true">
                          <use xlinkHref="#icon-hidream-msiyuliuliang"></use>
                        </svg>
                        <div className="tag_name">私域流量打造</div>
                      </div>
                      <div className="col">
                        <svg className="icon" aria-hidden="true">
                          <use xlinkHref="#icon-hidream-mshemeiyunying"></use>
                        </svg>
                        <div className="tag_name">社媒运营</div>
                      </div>
                      <div className="col">
                        <svg className="icon" aria-hidden="true">
                          <use xlinkHref="#icon-hidream-mpinpaiyingxiao"></use>
                        </svg>
                        <div className="tag_name">品牌营销</div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>
            </div>
          </div>

          <div className="home_customers">
            <div className="header">
              <div className="section_header">
                <h3 className="title_cn">我们的客户</h3>
                <p className="title_en">Our client</p>
              </div>
            </div>

            <div className="section_content">
              <ul className="row">
                {clientLogos.map((item) => (
                  <li className="col" key={item.alt}>
                    <Image src={item.img} alt={item.alt} />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Home;

class Tab extends Component {
  state = {
    currentIndex: 0,
  };

  isTitleActive(index) {
    return index === this.state.currentIndex ? 'title active' : 'title';
  }

  isContentActive(index) {
    return index === this.state.currentIndex ? 'item show' : 'item';
  }

  render() {
    return (
      <div className="tab">
        <div className="tab_title">
          {React.Children.map(this.props.children, (element, index) => {
            return (
              <div
                onClick={() => {
                  this.setState({ currentIndex: index });
                }}
                className={this.isTitleActive(index)}
                key={index}
              >
                {element.props.name}
              </div>
            );
          })}
        </div>
        <div className="tab_content">
          {React.Children.map(this.props.children, (element, index) => {
            return (
              <div className={this.isContentActive(index)} key={index}>
                {element}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
